import { atom, useAtom } from 'jotai';
import type { GullakTaskRes } from '@/types/api/gullak-cash/gullak-task';
import type { HomeRes } from '@/types/api/gullak-cash/home';
import type { BalanceRes } from '@/types/api/gullak-cash/balance';
import type { VipRulesRes } from '@/types/api/gullak-cash/vip-rules';
import { GullakClaimStatus } from '@/features/gullak-cash/constants';
import { getGullakBalance } from '@/features/gullak-cash/services';

type TaskItem = NonNullable<GullakTaskRes['tasks']>[0];

// 存储任务列表数据
export const gullakTaskListAtom = atom<TaskItem[]>([]);

// 存储任务列表的总数
export const gullakTaskTotalAtom = atom<number>(0);

// 存储任务列表的加载状态
export const gullakTaskLoadingAtom = atom<boolean>(true);

// 存储首页数据（用于跨组件共享）
export const gullakHomeDataAtom = atom<HomeRes | null>(null);

// 存储余额数据（用于入口轮询展示）
export const gullakBalanceAtom = atom<BalanceRes | null>(null);

// 存储 VIP 规则数据
export const gullakVipRulesAtom = atom<VipRulesRes | null>(null);

// 存储 VIP 规则加载状态
export const gullakVipRulesLoadingAtom = atom<boolean>(false);

/**
 * 可写的 atom：将 gullakBalanceAtom 的 is_claim 设置为已领取
 */
export const setGullakBalanceAsClaimedAtom = atom(
  null,
  (get, set) => {
    const currentBalance = get(gullakBalanceAtom);
    if (currentBalance) {
      set(gullakBalanceAtom, {
        ...currentBalance,
        is_claim: GullakClaimStatus.Claimed,
      });
    }
  }
);

export const useGullakBalanceManager = () => {
  const [gullakBalance, setGullakBalance] = useAtom(gullakBalanceAtom);

  /**
   * 通过 API 更新计数
   */
  const updateGullakBalance = async () => {
    try {
      const response = await getGullakBalance();
      setGullakBalance(response);
      return response;
    } catch (error) {
      console.error('Failed to update reward count:', error);
      throw error;
    }
  }

  return {
    gullakBalance,
    setGullakBalance,
    updateGullakBalance,
  };
};
